import $ from 'jquery';

export default (container = document) => {
  $('[data-rte-offset-captions]', container).each((i, captions) => {
    const $captions = $(captions);
    const main_index = $captions.data('main');
    const $main = $captions.children().eq(main_index);
    $captions.wrap('<div class="RteOffsetCaptions__wrapper"></div>');
    $captions.addClass('RteOffsetCaptions');
    $captions.children().addClass('RteOffsetCaption');
    $main.addClass('RteOffsetCaption--main');
    $captions.parent('.RteOffsetCaptions__wrapper').wrap(`
      <section class="Section Section--fixed Section--mobile-full Animate Animate--slide-up">
        <div class="Section__container">
        </div>
      </section>
    `);
  });
};